import { AIConfigModalValues } from '@dc-shared-web/components/features/AIConfigDialog/types'
import {
  ChatError,
  ChatErrorType,
  ChatModelProvider,
  ChatSettings,
} from '@dc-shared-web/providers/ChatProvider/types'

const getDefaultModelProvider = (providers?: ChatModelProvider[]) => {
  return providers?.find((provider) => provider.default)?.id
}

const getDefaultModel = (
  providerId?: string,
  providers?: ChatModelProvider[]
) => {
  return providers
    ?.find((provider) =>
      providerId ? provider.id === providerId : provider.default
    )
    ?.models.find((model) => model.default)?.id
}

export const getAIConfigModalConfigValues = (
  provided: ChatSettings | undefined,
  current: ChatSettings | undefined,
  defaults: ChatSettings | undefined
): AIConfigModalValues => {
  const systemPrompt = provided?.system || current?.system || ''
  const provider =
    provided?.provider ||
    current?.provider ||
    getDefaultModelProvider(defaults?.model_provider_map) ||
    'openai'
  const model =
    provided?.model ||
    current?.model ||
    getDefaultModel(provider, defaults?.model_provider_map) ||
    'gpt-4"'
  const contextMode =
    provided?.context_mode || current?.context_mode || 'paragraphs-only'
  const temperature = provided?.temperature || current?.temperature || 0.0
  const topP = provided?.top_p || current?.top_p || 0.0
  const provisions = provided?.provisions || current?.provisions || []

  return {
    systemPrompt,
    provider,
    model,
    contextMode,
    temperature,
    topP,
    provisions,
    context: provided?.context,
  }
}

export const getAIConfigModalDefaultValues = (
  defaults: ChatSettings | undefined
): AIConfigModalValues => ({
  systemPrompt: defaults?.system || '',
  provider: defaults?.provider || 'openai',
  model: defaults?.model || 'gpt-4',
  contextMode: defaults?.context_mode || 'paragraphs-only',
  temperature: defaults?.temperature || 0.0,
  topP: defaults?.top_p || 0.0,
  provisions: defaults?.provisions || [],
})

export const documentNeedsRecrunch = (errors: ChatError[]) => {
  return errors.some(
    (error) =>
      error.type === ChatErrorType.DocumentNotIndexed ||
      error.type === ChatErrorType.DocIdNotFound ||
      error.type === ChatErrorType.MissingDocGUID
  )
}
